import React, { useEffect, useRef, useState } from "react";
import "./overView.scss";
import {
  BeditOverviewData,
  BeditProfileData,
} from "../../../../components/Data/bEditData";
import RadioButton from "../../../../components/RadioButton/RadioButton";
import {
  editIconBlue,
  orangeRightTick,
  sustainableLeafIcon,
} from "../../../../images";
import { Link } from "react-router-dom";
import AboutPopUp from "../../BusinessProfileComponents/PopUpComponents/AboutPopUp/AboutPopUp";
import OurFocus from "../../BusinessProfileComponents/PopUpComponents/OurFocus/OurFocus";
import AboutPopupV2 from "../../BusinessProfileComponents/PopUpComponents/AboutPopupV2/AboutPopupV2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useWindowSize } from "react-use";
import helper from "../../../../helpers/helper";
import useTheme from "../../../../components/useTheme/useTheme";

const OverView2 = ({
  isActive,
  isSubtabActive,
  overviewData,
  globalData,
  isOnline,
  scrollingTextData,
  focusScrollingTextData,
  handleExcelPopupOpen,
  workflowQuestions,
  handleGeneralInfoPopupOpen,
  containerRef,
  imageAssets,
}) => {
  const { theme } = useTheme();
  const [isAboutModal, setIsAboutModal] = useState(false);
  const [showOurFocusPopup, setShowOurFocusPopup] = useState(false);
  const swiperRef = useRef(null);
  const [modalType, setModalType] = useState("");
  const [isProductServExpanded, setIsProductServExpanded] = useState(false);
  const handleShow = () => setIsAboutModal(true);
  const handleHide = () => setIsAboutModal(false);
  const handleOurFocusPopupOpen = () => setShowOurFocusPopup(true);
  const handleOurFocusPopupClose = () => setShowOurFocusPopup(false);
  const { width } = useWindowSize();
  const containerRefOurFocus = useRef(null);
  const servicesTrackRef = useRef(null);
  const servicesAnimFrameRef = useRef(null);

  const {
    locationOrange,
    editIconBlue,
    bookmark_black,
    suitCase_black,
    employeesBlack,
  } = imageAssets;

  // About section
  const handleAboutShow = () => {
    setModalType("about");
    setIsAboutModal(true);
  };

  // Products/Services
  const handleProductsShow = () => {
    setModalType("products");
    setIsAboutModal(true);
  };

  const handleHideModal = () => {
    setIsAboutModal(false);
    setModalType(""); // Modal close
  };

  // Drag-to-scroll logic for rating_container
  useEffect(() => {
    const slider = containerRef.current;
    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
    };

    const handleMouseUp = () => {
      isDown = false;
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed multiplier
      slider.scrollLeft = scrollLeft - walk;
    };

    slider?.addEventListener("mousedown", handleMouseDown);
    slider?.addEventListener("mouseleave", handleMouseLeave);
    slider?.addEventListener("mouseup", handleMouseUp);
    slider?.addEventListener("mousemove", handleMouseMove);

    return () => {
      slider?.removeEventListener("mousedown", handleMouseDown);
      slider?.removeEventListener("mouseleave", handleMouseLeave);
      slider?.removeEventListener("mouseup", handleMouseUp);
      slider?.removeEventListener("mousemove", handleMouseMove);
    };
  }, [containerRef]);

  // Map scrollingTextData to SwiperSlides
  const scrollingText = scrollingTextData.map((item, i) => (
    <SwiperSlide key={i}>
      <p
        className="scrolling_text"
        dangerouslySetInnerHTML={{ __html: item }}
      ></p>
    </SwiperSlide>
  ));

  // Map focusScrollingTextData to SwiperSlides
  const focusScrollingText = focusScrollingTextData?.map((item, i) => (
    <SwiperSlide key={i}>
      <p
        className="scrolling_text"
        dangerouslySetInnerHTML={{ __html: item }}
      ></p>
    </SwiperSlide>
  ));

  useEffect(() => {
    const slider = containerRefOurFocus.current;
    if (!isOnline || !slider) return;
    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
    };

    const handleMouseUp = () => {
      isDown = false;
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed multiplier
      slider.scrollLeft = scrollLeft - walk;
    };

    // Add event listeners
    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseleave", handleMouseLeave);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);

    // Cleanup
    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
      slider.removeEventListener("mouseleave", handleMouseLeave);
      slider.removeEventListener("mouseup", handleMouseUp);
      slider.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isOnline]);

  // Scrolling animation for Products/Services pills
  useEffect(() => {
    const track = servicesTrackRef.current;
    if (!track) return;

    let offset = 0;
    const speed = 0.5;

    const animate = () => {
      offset -= speed;
      const width = track.scrollWidth / 2;
      if (Math.abs(offset) >= width) {
        offset = 0;
      }
      track.style.transform = `translateX(${offset}px)`;
      servicesAnimFrameRef.current = requestAnimationFrame(animate);
    };

    servicesAnimFrameRef.current = requestAnimationFrame(animate);
    return () => {
      if (servicesAnimFrameRef.current) {
        cancelAnimationFrame(servicesAnimFrameRef.current);
      }
    };
  }, []);

  const overviewDataMapped = [
    {
      about: [
        {
          title: "About",
          ctaText: "Edit | View",
          desc: [`${overviewData?.bio || ""}`],
        },
      ],
      products: [
        {
          title: "Products/Services",
          radioField: overviewData?.featured_services,
          allServices: [
            ...(overviewData?.featured_services || []),
            ...(overviewData?.services || []).filter(
              (s) => !(overviewData?.featured_services || []).includes(s)
            ),
          ],
        },
      ],
      focus: [
        {
          title: "Our Focus",
          ctaText: "Edit | View",
          focusData: overviewData?.product_positionings || [],
        },
      ],
    },
  ];

  return (
    <>
      <div
        className={`profile_overview_container ${
          theme === "dark" && "profile_overview_container--dark-mode"
        }`}
      >
        <div className="my_container p-0">
          <div className="overview_container">
            {/* {BeditProfileData[isActive]?.subTab?.map( */}
            {overviewDataMapped.map(
              (data, index) =>
                data?.about && (
                  <div
                    className={`data_container ${
                      isSubtabActive === index ? "active" : ""
                    }`}
                    key={index}
                  >
                    {data?.about?.map((about, i) => (
                      <div className={`about_container`} key={`about-${i}`}>
                        <div className="text_container">
                          <div className="cta_container">
                            <h2 className="title">{about.title}</h2>
                            <div
                              className="cta_wrapper p-0"
                              onClick={handleAboutShow}
                            >
                              <img
                                src={editIconBlue}
                                alt="edit icon"
                                className="edit_icon"
                              />
                              <Link
                                to={() => false}
                                className="bedit_common_cta"
                              >
                                {about.ctaText}
                              </Link>
                            </div>
                          </div>
                          {/* Since year - right below About heading */}
                          {overviewData?.establishment_year?.data && (
                            <p className="establishment_year_text">
                              Since : {overviewData.establishment_year.data}
                            </p>
                          )}
                          {about.desc[0] === "" && (
                            <p
                              className="desc mb-0"
                              key={i}
                              style={{
                                fontStyle: "italic",
                              }}
                            >
                              Write your professional bio here...
                            </p>
                          )}

                          {about?.desc?.map((item, i) => (
                            <p
                              className="desc"
                              dangerouslySetInnerHTML={{ __html: item }}
                              key={i}
                              style={{
                                opacity: !isOnline ? "0.2" : "1",
                              }}
                            ></p>
                          ))}
                        </div>
                      </div>
                    ))}
                    {/* Location and Team members side by side */}
                    <div className="location_employees_row">
                      <div className="select_field_container">
                        {overviewData?.addresses?.length > 0 ? (
                          <>
                            <img
                              src={locationOrange}
                              alt="location"
                              className="location_icon"
                            />
                            <p className="select_title">
                              Location :
                            </p>
                            <div
                              className="select_field"
                              style={{ background: "none" }}
                            >
                              {helper?.truncateName(
                                overviewData.addresses[0]?.address,
                                25
                              )}
                            </div>
                          </>
                        ) : (
                          <p
                            className="desc mb-0"
                            style={{
                              fontStyle: "italic",
                            }}
                          >
                            Location
                          </p>
                        )}
                        {/* Edit | View removed - handled by About Edit | View
                        <Link
                          to={() => false}
                          className="bedit_common_cta"
                          onClick={handleGeneralInfoPopupOpen}
                        >
                          <img
                            src={editIconBlue}
                            alt="edit icon"
                            className="edit_ic"
                          />
                          Edit | View
                        </Link>
                        */}
                      </div>

                      <div className="rating_container" ref={containerRef}>
                        <div className="rating_status">
                          <img
                            src={employeesBlack}
                            alt="verified"
                            className="emp_icon"
                          />
                          <p className="rating_text">
                            {overviewData?.team_range?.data ||
                              "Add Number of Employees"}{" "}
                            Employees
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Products/Services */}
                    <div className="wrp_pr_serv_loc">
                      {data?.products?.map((product, i) => (
                        <div
                          className="product_container pr_cont_ov2"
                          key={`product-${i}`}
                        >
                          <div className="wrp_edt_cta_prd_serv">
                            {/* <h2 className="sub_title">{product.title}</h2> */}
                            {/* Edit | View removed - handled by About Edit | View
                            <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
                              <div
                                className="cta_wrapper p-0 wrp_edt"
                                onClick={handleProductsShow}
                              >
                                <img
                                  src={editIconBlue}
                                  alt="edit icon"
                                  className="edit_icon"
                                />
                                <Link
                                  to={() => false}
                                  className="bedit_common_cta"
                                >
                                  Edit | View
                                </Link>
                              </div>
                            </div>
                            */}
                          </div>
                          <div
                            className="scrolling-services-wrapper"
                            style={{
                              opacity: !isOnline ? "0.2" : "1",
                            }}
                          >
                            <div className="scrolling-services-track" ref={servicesTrackRef}>
                              {[...(product?.radioField || []), ...(product?.radioField || [])].map((radio, index) => (
                                <span key={`scroll-${index}`} className="service-pill">
                                  {radio}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Our Focus */}
                    <div className="scroll_text_container focus_scroll_container">
                      <div className="wraper_scroling_txt">
                        <div className="title">Our Focus</div>
                        {overviewData?.product_positionings?.length > 0 ? (
                          <div
                            className="focus_wrapper"
                            ref={containerRefOurFocus}
                            style={{
                              opacity: !isOnline ? "0.2" : "1",
                            }}
                          >
                            {overviewData.product_positionings.map(
                              (item, index) => (
                                <div className="focus_box" key={index}>
                                  {item !== "Sustainable" ? (
                                    <img
                                      src={orangeRightTick}
                                      alt="right tick"
                                      className="focus_img"
                                    />
                                  ) : (
                                    <img
                                      src={sustainableLeafIcon}
                                      alt="right tick"
                                      className="focus_img"
                                    />
                                  )}
                                  <p className="focus_title">{item}</p>
                                </div>
                              )
                            )}
                          </div>
                        ) : (
                          <p
                            className="desc mb-0"
                            style={{
                              fontStyle: "italic",
                            }}
                          >
                            Pick words that apply to your market positioning
                          </p>
                        )}
                        {focusScrollingTextData?.length > 0 && (
                          <Swiper
                            key="focus-swiper"
                            direction={"vertical"}
                            className="scroll_text_slider focus_scroll_text_slider"
                            effect="slide"
                            loop={true}
                            modules={[Autoplay]}
                            allowTouchMove={true}
                            speed={1200}
                            autoplay={{
                              delay: 2000,
                              disableOnInteraction: false,
                            }}
                            observer={true}
                            observeParents={true}
                            style={{
                              opacity: !isOnline ? "0.2" : "1",
                            }}
                          >
                            {focusScrollingText}
                          </Swiper>
                        )}
                      </div>

                      <div onClick={handleOurFocusPopupOpen}>
                        <Link
                          to={() => false}
                          className="bedit_common_cta position-absolute cta_ed_wxl"
                          style={{ right: "0" }}
                        >
                          <img
                            src={editIconBlue}
                            alt="edit icon"
                            className="edit_ic"
                          />
                          Edit | View
                        </Link>
                      </div>
                    </div>

                    {/* Where We Excel */}
                    <div className="scroll_text_container">
                      <div className="wraper_scroling_txt">
                        <div className="title">Where We Excel</div>
                        {scrollingTextData?.length > 0 ? (
                          <Swiper
                            key="excel-swiper"
                            direction={"vertical"}
                            ref={swiperRef}
                            className="scroll_text_slider"
                            effect="slide"
                            loop={true}
                            modules={[Autoplay]}
                            allowTouchMove={true}
                            speed={1200}
                            autoplay={{
                              delay: 2000,
                              disableOnInteraction: false,
                            }}
                            observer={true}
                            observeParents={true}
                            style={{
                              opacity: !isOnline ? "0.2" : "1",
                            }}
                          >
                            {scrollingText}
                          </Swiper>
                        ) : (
                          <p
                            className="desc mb-0"
                            style={{
                              fontStyle: "italic",
                            }}
                          >
                            Fill in your project details
                          </p>
                        )}
                      </div>

                      <div onClick={handleExcelPopupOpen}>
                        <Link
                          to={() => false}
                          className="bedit_common_cta position-absolute cta_ed_wxl"
                          style={{ right: "0" }}
                        >
                          <img
                            src={editIconBlue}
                            alt="edit icon"
                            className="edit_ic"
                          />
                          Edit | View
                        </Link>
                      </div>
                    </div>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
      {/* <AboutPopUp
        show={isAboutModal}
        onHide={() => setIsAboutModal(false)}
        handleClose={handleHide}
        data={overviewData}
        globalData={globalData}
      /> */}
      <AboutPopupV2
        show={isAboutModal}
        onHide={() => setIsAboutModal(false)}
        handleClose={handleHide}
        data={overviewData}
        globalData={globalData}
        modalType={modalType}
      />
      <OurFocus
        show={showOurFocusPopup}
        handleClose={handleOurFocusPopupClose}
        data={overviewData}
        globalData={globalData}
        workflowQuestions={workflowQuestions}
      />
    </>
  );
};

export default OverView2;
